import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import RiderTripTable from '../../../components/table/RiderTripTable'
import { lightBlue } from '@mui/material/colors'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import { Breadcrumbs, Typography } from '@mui/material'

const Single = ({user}) => {

  const {paymentId} = useParams()


  const [ paymentData, setPaymentData ] = useState("")

  const [openStatus, setOpenStatus] = useState(false)

  const options = {  maximumFractionDigits: 2 }

 
  const getPaymentInfo = () => {

    onSnapshot(doc(db, "PaymentInfo", paymentId), (doc) => {
  
     console.log("Current data: ", doc.data());
  
  
    setPaymentData({id: doc.id, ...doc.data(), date: doc.data().timeStamp.toDate().toLocaleString(), reference: Object.values(doc.data().payment.transactionRef.reference)})
  
    
   });
  
  
  }

  useEffect(()=>{

    getPaymentInfo()
    

  }, [])


  
    const handleStatus = async() => {
  
      
      const paymentRef = doc(db, "PaymentInfo", paymentId);
  
      await updateDoc(paymentRef, {
  
      status: paymentData.status === "active" ? 'inactive' : 'active', 
  
   })
  
    setOpenStatus(false)
  
    }
  




  return (
    <>

<div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
          {/* <div style={{display:'flex', alignSelf:'flex-end', justifyContent:'flex-end', marginRight:30, marginTop:20, marginBottom:20}}>
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link underline="hover" color="inherit" href="/">
                        Home
                      </Link>
                      <Link
                        underline="hover"
                        color="inherit"
                        // href="/staff"
                      >
                        Staff List
                      </Link>
                      <Typography color="green">Staff</Typography>
                    </Breadcrumbs>
          </div> */}
        <div className="top">
            
          <div className="left">
            <h2 className='title'>Payment Information</h2>
            <div className='item'>
         
               
                <div className="details">
                

                  <div className='detailItem'>
                    <span className='itemKey'>Plan Amount:</span>
                    <span className='itemValue'>N{Intl.NumberFormat("en-US",options).format(paymentData.amount)}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Subscription Plan:</span>
                    <span className='itemValue'>{paymentData.plan}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Date of Payment:</span>
                    <span className='itemValue'>{paymentData.date}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Expiration Date:</span>
                    <span className='itemValue'>{paymentData.expiration}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Reference:</span>
                    <span className='itemValue'>{paymentData.reference}</span>
                  </div>
                   <div className='detailItem'>
                    <span className='itemKey'>Payment Status:</span>
                    <span className='itemValue'>{paymentData.transactionStatus? 'Successful':'Failed'}</span>
                  </div>
                
                </div>

              

            </div>
          </div>

           <div className="left">
            <h2 className='title'>Outlet Information</h2>
            <div className='item'>
         
               
                <div className="details">

                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Name:</span>
                    <span className='itemValue'>{paymentData.outletname}</span>
                  </div>
                

                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Type:</span>
                    <span className='itemValue'>{paymentData.outlet}</span>
                  </div>
                  {/* <div className='detailItem'>
                    <span className='itemKey'>Date of Payment:</span>
                    <span className='itemValue'>{paymentData.date}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Expiration Date:</span>
                    <span className='itemValue'>{paymentData.expiration}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Reference:</span>
                    <span className='itemValue'>{paymentData.reference}</span>
                  </div> */}
                
                </div>

              

            </div>
          </div>

            <div className="left">
            <h2 className='title'>Subscriber Information</h2>
            <div className='item'>
         
               
                <div className="details">
                

                  <div className='detailItem'>
                    <span className='itemKey'>Subscriber Firstname:</span>
                    <span className='itemValue'>{paymentData.firstname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Subscriber Lastname:</span>
                    <span className='itemValue'>{paymentData.lastname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Phone Number:</span>
                    <span className='itemValue'>{paymentData.telephone}</span>
                  </div>
                  {/* <div className='detailItem'>
                    <span className='itemKey'>Expiration Date:</span>
                    <span className='itemValue'>{paymentData.expiration}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Reference:</span>
                    <span className='itemValue'>{paymentData.reference}</span>
                  </div> */}
                
                </div>

              

            </div>
          </div>
      
        
        </div>
      
        <div className="bottom">
         
        </div>
      </div>
     
    </div>
      <ConfirmStatusBox
        openStatus={openStatus}
        closeDialog={() => setOpenStatus(false)}
        statusFunction={handleStatus }
      />
    </>
 
  )
}

export default Single












// import React, { useEffect, useState } from 'react'
// import './single.scss'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
// import { doc, getDoc } from "firebase/firestore"
// import { useHistory, useParams } from "react-router-dom"
// import { db } from '../../../firebase'
// import RiderTripTable from '../../../components/table/RiderTripTable'

// const Single = ({rider}) => {

//   const {riderId} = useParams()


//   const [ riderData, setRiderData ] = useState("")

//   // const [ orderData, setOrderData ] = useState([])

//   const getRider = async() => {

//       const docRef = doc(db, "riders", riderId);

//       const docSnap = await getDoc(docRef);

    
      
//       if (docSnap.exists()) {

//         setRiderData(docSnap.data())
//         // console.log(riderData)
//       } else {
//         // doc.data() will be undefined in this case
//         console.log("No such document!");
//       }
//   }

//   useEffect(()=>{

//     getRider()

//   }, [])


//   // useEffect(() => {
    
//   //   //LISTEN REAL TIME

//   //   const orderQuery = async() => {

//   //     const orderRef = (collection(db, "order"));
//   //     const q = query(orderRef, where("riderId", "=="etRiderId));

//   //     const querySnapshot = await getDocs(q);
//   //       let list = []
//   //     querySnapshot.forEach((doc) => {
//   //       // doc.data() is never undefined for query doc snapshots
//   //       list.push(doc.data())
//   //       // console.log(doc.id, " => ", doc.data());
//   //       console.log(list)

//   //       setOrderData(list)
//   //       // console.log(orderData)
//   //     });

//   //     // setOrderData(doc.data())
//   //     // console.log(orderData)

//   //   }
    
//   //   orderQuery()   
//   // },[])
 

//   return (
//     <div className='single'>
//       <Sidebar/>
//       <div className='singleContainer'>
//         <Navbar/>
//         <div className="top">
//           <div className="left">
//             {/* <div className="editbutton">Edit</div> */}
//             <h2 className='title'>Rider Information</h2>
//             <div className='item'>
//             <img
//                 src = {riderData.riderPhoto ? riderData.riderPhoto : "../images/avatar.jpg"}
//                 alt="avatar"
//                 style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
//             /> 
              

          
               
//                 <div className="details">
//                   <h3 className='itemTitle'>{riderData.fullname}</h3>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Email:</span>
//                     <span className='itemValue'>{riderData.email}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Phone:</span>
//                     <span className='itemValue'>{riderData.telephone}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Date of Birth:</span>
//                     <span className='itemValue'>{riderData.dateOfBirth}</span>
//                   </div>
//                   {/* <div className='detailItem'>
//                     <span className='itemKey'>Registered:</span>
//                     <span className='iitemValue'>{riderData.timeStamp}</span>
//                   </div> */}
//                 </div>

//                 <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Gender:</span>
//                     <span className='itemValue'>{riderData.sex}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Date Joined:</span>
//                     {/* <span className='itemValue'>{riderData.timeStamp}</span> */}
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Status:</span>
//                     <span className='itemValue'>Active</span>
//                   </div>
//                   {/* <div className='detailItem'>
//                     <span className='itemKey'>Registered:</span>
//                     <span className='iitemValue'>{riderData.timeStamp}</span>
//                   </div> */}
//                 </div>
//             </div>
//           </div>
//           <div>
//             <Chart 
//               aspect={3/1}
//               title = "Rider purchase last 6 months"
//             />
//           </div>
//         </div>
//         <div className="bottom">
//         <div className='listTitle'>Rider Transactions History</div>
//           <RiderTripTable
//                 riderId = {riderId}
//           />
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Single